import { Grid } from './Grid';

// TODO: in v9, move styled() from Grid.jsx to here
export var StyledGrid = Grid;